import {AfterViewInit, Component, OnInit, Renderer2} from "@angular/core";
import {ToastsManager} from "ng2-toastr";
import { ActivatedRoute } from "@angular/router";
import { RNSService } from "../../services/RNS.service";
import { ConfigService } from "../../services/configService";

@Component({
    selector: "pars-status-refresh",
    templateUrl: "./pars-status-refresh.component.html",
    styleUrls: ['../../../theme/scss/pars-status-refresh.scss'],
    moduleId: module.id.toString()
})
export class ParsStatusRefreshComponent implements OnInit, AfterViewInit{

    public spinner: HTMLElement;

    public parsNumber: string;
    public statusQueryId: number;
    public showLoader: boolean;
    public counter: number;
    private intervalId: NodeJS.Timer;

    constructor(private renderer: Renderer2,
                private route: ActivatedRoute,
                private configService: ConfigService,
                private rnsService: RNSService,
                public toastsManager: ToastsManager) {
    }

    ngOnInit() {
        this.statusQueryId = this.route.snapshot.queryParams['sq'];
        this.parsNumber = this.route.snapshot.queryParams['pn'];
        this.showLoader = true;
    }

    ngAfterViewInit() {
       this.spinner = document.getElementById("spinner");
       this.renderer.addClass(this.spinner, "hide");
       
       this.rnsService.refreshStatus(this.statusQueryId)
       .then(() => {
           this.showLoader = false;
           this.counter = 5;
           this.intervalId = setInterval(() => {
               if (this.counter === 0){
                   clearInterval(this.intervalId);
                   window.open('https://borderbuddy.com/PARS', "_self");
                   return;
               }

               this.counter -= 1;
           }, 1000);
       })
       .catch((r) => console.log(r));
    }
}


// WEBPACK FOOTER //
// ./app/components/pars-status-widget/pars-status-refresh.component.ts